export const headers = { 'Authorization': `Bearer ${process.env.REACT_APP_strapiToken}` };
export const cmsHeaders = { 'Authorization': `Bearer ${process.env.REACT_APP_cmsToken}` };
export const cmsEnv = {'x-env': `${process.env.REACT_APP_ENV}`}
